import {
  AdjustmentSourceType,
  AdjustmentType,
  Adjustment,
} from '../types/generated/graphql-types'

export const PRICING_EXCEPTION_ADJUSTMENT_TITLE = 'Pricing Exception'

/**
 * Calculate the pricing exception percentage based on the pricing exception amount and loan amount.
 * Formula: (pricing exception amount / loan amount) * 100 * -1, limited to 3 decimal places
 *
 * @param exceptionAmount The pricing exception dollar amount
 * @param loanAmount The loan amount
 * @param createAdjustment If true, creates and returns an adjustment object instead of just the percentage
 * @returns The pricing exception as a percentage value, or an adjustment object
 */
export function calculatePricingExceptionPercentage({
  exceptionAmount,
  loanAmount,
  createAdjustment = false,
}: {
  exceptionAmount: number
  loanAmount: number
  createAdjustment?: boolean
}): number | Adjustment | null {
  if (!exceptionAmount || !loanAmount || loanAmount <= 0) {
    return createAdjustment ? null : 0
  }

  const percentage = parseFloat(
    ((exceptionAmount / loanAmount) * 100 * -1).toFixed(3)
  )

  if (!createAdjustment) {
    return percentage
  }

  // Return the adjustment object directly
  return {
    title: PRICING_EXCEPTION_ADJUSTMENT_TITLE,
    amount: percentage,
    isHidden: false,
    isStop: false,
    isCompAdjustment: true,
    filter: null,
    adjustmentSourceType: AdjustmentSourceType.BusinessRule,
    adjustmentType: AdjustmentType.Margin,
  }
}
